const LoadingSpinner = ({ message = 'Loading...', size = 'medium' }) => {
  const sizeClasses = {
    small: 'w-5 h-5',
    medium: 'w-16 h-16',
    large: 'w-24 h-24',
  };

  const borderClasses = {
    small: 'border-2',
    medium: 'border-4',
    large: 'border-4',
  };

  // Small size is designed for inline use (inside buttons) — no padding or message
  if (size === 'small') {
    return (
      <div className="flex items-center justify-center">
        <div className={`${sizeClasses.small} ${borderClasses.small} border-current/30 border-t-current rounded-full animate-spin`}></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`${sizeClasses[size]} ${borderClasses[size]} border-gold/20 border-t-gold rounded-full animate-spin`}></div>
      {message && (
        <p className="mt-4 text-neutral-grey">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
